import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import httpService from '@/services/http'
import '@/assets/scss/_variables.scss'
import 'bootstrap/scss/bootstrap.scss'
import * as bootstrap from 'bootstrap'
import '@fortawesome/fontawesome-free/css/all.css'

// 安裝 vue-meta
Vue.use(VueMeta)

// Make bootstrap available globally
window.bootstrap = bootstrap

// 創建事件總線
Vue.prototype.$eventBus = new Vue()

// 配置 HTTP 服务为全局属性
Vue.prototype.$http = httpService
// 将 router 注入到 http service 以支持导航
httpService.setRouter(router)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 